import React, { Component } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import './Menu.css';
import logo from './imgs/r-telecom_logo.png';
import createHistory from 'history/createBrowserHistory';
import { connect } from 'react-redux';
import { modalClose } from "../../actions/ModalActions";

const items = [
  {
    "text": "О компании",
    "modifier": "about",
    "to": "about"
  },
  {
    "text": "Вакансии",
    "modifier": "vacancies",
    "to": "vacancies"
  },
  {
    "text": "Стажировка",
    "modifier": "internships",
    "to": "internships"
  },
  {
    "text": "Советы соискателям",
    "modifier": "help",
    "to": "help"
  },
  {
    "text": "Истории успеха",
    "modifier": "workers",
    "to": "workers"
  }
]

class Menu extends Component {
  state = {
    isOpen: false
  }

  onClickItem = () => {
    this.setState({
      isOpen: false
    })
  }

  onClickBackItem = () => {
    if (!this.props.modal.opened) {
      this.onClickItem();
      createHistory().goBack();
    } else {
      this.props.onClickBackItem();
    }
  }

  onSwitcherClick = () => {
    this.setState((prevState, props) => {
      return {
        isOpen: !this.state.isOpen
      }
    })
  }

  render() {
    let menuModifier = ""
    if (typeof(document) !== 'undefined') {
      if (this.state.isOpen) {
        document.body.style.overflow = 'hidden';
        menuModifier += " menu--open"
      } else if (!this.state.isOpen) {
        document.body.removeAttribute('style');
      }
    }

    return (
      <div className={`menu ${menuModifier ? menuModifier : ''}`}>
        <nav className="menu__wrapper">
          <Link onClick={this.onClickItem} className="menu__logoLink" to='/'>
            <img className="menu__logo" src={logo} alt="r-telecom" />
          </Link>
          <div className="menu__back" onClick={this.onClickBackItem} />
          <div className="menu__switcherWrapper" onClick={this.onSwitcherClick}>
            <div className="menu__switcher" />
          </div>
          <ul className="menu__list">
            {
              items.map((item, index) => (
                <li className="menu__item" key={`menu__item-${index}`}>
                  <NavLink onClick={this.onClickItem} to={`/${item.to}`} activeClassName={"menu__link--active"} className={`menu__link menu__link--${item.modifier}`}>
                    {item.text}
                  </NavLink>
                </li>
              ))
            }
          </ul>
        </nav>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    modal: state.modal,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickBackItem: () => {
      dispatch(modalClose());
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/index.js